"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_data_table_component_1 = __importDefault(require("react-data-table-component"));
const _variables_scss_1 = __importDefault(require("../../scss/_variables.scss"));
const DataTableTheme_1 = __importDefault(require("../enums/DataTableTheme"));
// The <T,> is needed because of a clash between JSX and Typescript, see: https://github.com/microsoft/TypeScript/issues/15713#issuecomment-499474386
const TableSub = (props) => {
    const { data, columns, className, tableProps = {}, noDataComponent } = props;
    const dataTableStyles = {
        table: {
            style: {
                borderWidth: '1px',
                borderColor: _variables_scss_1.default.gray_200,
                borderStyle: 'solid',
                borderRadius: '0.375rem',
                paddingLeft: '1.25rem',
                paddingRight: '1.25rem',
                width: 'calc(100% - 1rem)',
            },
        },
        headRow: {
            style: {
                minHeight: '1.625rem',
            },
        },
        headCells: {
            style: {
                color: _variables_scss_1.default.secondary,
                fontSize: '0.875rem',
                lineHeight: '1.25rem',
                fontWeight: 'bold',
                paddingTop: '0.625rem',
                paddingBottom: '0.625rem',
            },
        },
        rows: {
            style: {
                minHeight: '2.5rem',
            },
        },
        cells: {
            style: {
                fontSize: '0.875rem',
                lineHeight: '1.25rem',
            },
        },
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-table-sub', className) },
        react_1.default.createElement(react_data_table_component_1.default, { ...tableProps, columns: columns, data: data, theme: DataTableTheme_1.default.sub, noHeader: true, customStyles: dataTableStyles, responsive: false, noDataComponent: noDataComponent })));
};
exports.default = (0, mobx_react_1.observer)(TableSub);
